const parseDate = (value) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value || ""));
  if (!match) return null;
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const date = new Date(Date.UTC(year, month - 1, day));
  if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) {
    return null;
  }
  return date;
};

const monthIndex = (date) => date.getUTCFullYear() * 12 + date.getUTCMonth();
const lastDay = (year, month) => new Date(Date.UTC(year, month + 1, 0)).getUTCDate();

export function deriveInstallmentScheduleDates(loanStartDate, maturityDate, installmentMonth) {
  const loan = parseDate(loanStartDate);
  const maturity = parseDate(maturityDate);
  if (!loan || !maturity || maturity <= loan) return null;

  const repaymentDay = maturity.getUTCDate();
  let first = new Date(Date.UTC(
    loan.getUTCFullYear(),
    loan.getUTCMonth(),
    Math.min(repaymentDay, lastDay(loan.getUTCFullYear(), loan.getUTCMonth()))
  ));
  if (first < loan) {
    const nextMonth = new Date(Date.UTC(loan.getUTCFullYear(), loan.getUTCMonth() + 1, 1));
    first = new Date(Date.UTC(
      nextMonth.getUTCFullYear(),
      nextMonth.getUTCMonth(),
      Math.min(repaymentDay, lastDay(nextMonth.getUTCFullYear(), nextMonth.getUTCMonth()))
    ));
  }
  if (first > maturity) return null;

  const termMonths = monthIndex(maturity) - monthIndex(first) + 1;
  const viewedMonth = parseDate(`${String(installmentMonth || "").slice(0, 7)}-01`);
  const currentRound = viewedMonth
    ? Math.max(0, Math.min(termMonths, monthIndex(viewedMonth) - monthIndex(first) + 1))
    : null;

  return { termMonths, currentRound };
}
